import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COMPOUNDITEMMODAL_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Couleurs" },
  "background_color",
  "heading_color",
  "description_color",
  "inactive_state_color",
  "price_color",
  { type: 'separator' },
  "hide_addition_group_details"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  compoundItemModalDescriptor: _generatedCompoundItemModalDescriptor,
  compoundItemModalModalDefinition,
  compoundItemModalDashboardLayout,
  compoundItemModalConfig,
  compoundItemModalResolveConfig,
  compoundItemModalProperties,
} = doodModalConfig(
  {
    name: "Compound item modal",
    handle: "compound-item-modal",
    internal_name: "CompoundItemModal",
    componentType: 'CompoundItemModalComponent',
    category: 'modal',
    description: "Compound item modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "compound-item-modal",
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    }),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        "label": "Titres produits"
      }
    }),
    description_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-700"},
      options: {
        "label": "Description"
      }
    }),
    inactive_state_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-500"},
      options: {
        "label": "Etat inactif"
      }
    }),
    price_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-700"},
      options: {
        "label": "Prix"
      }
    }),
    hide_addition_group_details: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        "label": "Hide the text info of the number of product to choose"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "heading_color", "description_color", "inactive_state_color", "price_color", "hide_addition_group_details"],
          },
        ],
      },
    ],
  })
);

export function compoundItemModalDescriptor(): IBlockDescriptor;
export function compoundItemModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function compoundItemModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCompoundItemModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCompoundItemModalDescriptor, compoundItemModalProperties, fieldOrder);
}

export {
  compoundItemModalModalDefinition,
  compoundItemModalDashboardLayout,
  compoundItemModalProperties,
  compoundItemModalConfig,
  compoundItemModalResolveConfig,
};

export type CompoundItemModalConfig = typeof compoundItemModalConfig;
